import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-176223d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "main-container"
}
const _hoisted_3 = { class: "icon-text-container" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text-m-regular" }
const _hoisted_7 = { class: "icon-text-container" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text-m-regular" }
const _hoisted_11 = { class: "text-m-regular" }
const _hoisted_12 = { class: "icon-text-container" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "text-m-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_add_to_calendar = _resolveComponent("add-to-calendar")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_polygon_contact = _resolveComponent("polygon-contact")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, { "overlay-style": { backgroundColor: 'var(--color-secondary-lighter-35)' } }, {
    default: _withCtx(({ close, params }) => [
      _createElementVNode("button", {
        onClick: close,
        class: "close"
      }, [
        _createVNode(_component_use_svg, { svg: "close" })
      ], 8, _hoisted_1),
      (params.upcomingTask)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_base_card, { class: "card" }, {
              default: _withCtx(() => [
                _createVNode(_component_base_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate('overview.yourNextVisit')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_use_svg, { svg: "home" })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.request.address), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_use_svg, { svg: "clock" })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formatDate(params.upcomingTask.startDate, 'PPP')), 1),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDate(params.upcomingTask.startDate, 'p')) + " - " + _toDisplayString(_ctx.formatDate(params.upcomingTask.endDate, 'p')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_use_svg, { svg: "user" })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(params.upcomingTask.polygonEmployee.name), 1)
                  ])
                ]),
                _createVNode(_component_add_to_calendar, {
                  task: params.upcomingTask
                }, null, 8, ["task"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_polygon_contact, { "contact-type": "technician" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["overlay-style"]))
}